module.exports = __webpack_public_path__ + "img/empty-state.b19a3e63.png";